import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  const inclusions = ['Tu Semana Resuelta — el tablero visual', 'Sesiones de Alivio (20 min)', 'El Kit de Componentes', 'Así se Ensambla — guía visual', 'La Compra de Componentes', 'BONUS: El Botón de Pánico'];
  return <section id="oferta" className="py-12 md:py-24 px-4 bg-warm-100" data-id="element-165">
      <div className="max-w-3xl mx-auto" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-10" data-id="element-167">
          <p className="text-sm font-medium text-sage-dark tracking-widest uppercase mb-4" data-id="element-168">
            La oferta
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-warm-900 leading-tight mb-3 md:mb-4" data-id="element-169">
            Recupera tus noches <br data-id="element-170" />
            <span className="italic text-sage-dark font-medium" data-id="element-171">hoy mismo</span>
          </h2>
          <p className="text-lg text-warm-800/75 max-w-xl mx-auto" data-id="element-172">
            Elimina la fatiga de decisión. Obtén el sistema completo.
          </p>
        </motion.div>

        <motion.div id="oferta-card" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-[2rem] shadow-xl shadow-warm-900/5 border border-warm-200/60 overflow-hidden relative" data-id="element-173">
          <div className="h-1.5 w-full bg-sage-dark" data-id="element-174" />

          <div className="p-6 md:p-12" data-id="element-175">
            <div className="text-center mb-8 md:mb-10 pb-8 md:pb-10 border-b border-warm-200/60" data-id="element-176">
              <p className="text-warm-800/60 mb-2 text-sm uppercase tracking-wider font-medium" data-id="element-177">
                Sistema completo
              </p>
              <h3 className="font-heading text-2xl md:text-3xl font-semibold text-warm-900 mb-6" data-id="element-178">
                ¿Qué Cocino? Nunca Más
              </h3>

              <div className="flex items-baseline justify-center gap-2" data-id="element-179">
                <span className="text-6xl md:text-7xl font-bold text-warm-900 font-heading tracking-tight" data-id="element-180">
                  $27
                </span>
                <span className="text-xl text-warm-800/60 font-medium" data-id="element-181">
                  USD
                </span>
              </div>
              <p className="mt-3 text-sm text-warm-800/60 italic max-w-sm mx-auto" data-id="element-182">
                Menos de lo que cuesta pedir comida a domicilio una sola noche.
              </p>
            </div>

            <div className="space-y-3 md:space-y-3.5 mb-8 md:mb-10" data-id="element-183">
              {inclusions.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3 + index * 0.07
            }} className="flex items-start gap-3" data-id="element-184">
                  <div className="mt-1 bg-sage/15 rounded-full p-1 text-sage-dark shrink-0" data-id="element-185">
                    <CheckIcon className="w-3.5 h-3.5" strokeWidth={3} data-id="element-186" />
                  </div>
                  <span className="text-warm-800 leading-relaxed" data-id="element-187">{item}</span>
                </motion.div>)}
            </div>

            <motion.a href="https://vidaconmetodo.com/cart/44482692808819:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="flex items-center justify-center gap-2 w-full bg-sage-dark text-cream font-semibold py-5 px-8 rounded-2xl text-lg shadow-lg shadow-sage-dark/20 hover:shadow-xl hover:shadow-sage-dark/30 transition-all duration-300" data-id="element-188">
              Quiero la cena resuelta hoy mismo
              <ArrowRightIcon className="w-5 h-5" data-id="element-189" />
            </motion.a>

            <p className="mt-5 text-center text-warm-800/60 text-sm flex items-center justify-center gap-2" data-id="element-190">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500" data-id="element-191" />
              Un solo pago · Acceso de por vida
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}